exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tour-picker[data-v-0b28fe51]{border:1px solid #d5dde2;display:grid;grid-template-columns:1fr 1fr\n}\n.tour-picker__wrapper[data-v-0b28fe51]{grid-column:1/-1;margin:0 0 30px\n}\n.tour-picker__list[data-v-0b28fe51]{height:350px;overflow:scroll;padding:20px\n}\n.tour-picker__list input[data-v-0b28fe51]{display:none\n}\n.tour-picker__list input:checked+label[data-v-0b28fe51]{opacity:.5;pointer-events:none\n}\n.tour-picker__selected[data-v-0b28fe51]{border-left:1px solid #d5dde2\n}", ""]);

// exports
